import moment from 'moment'
import randomBytes from 'rand-token'

export default {
  namespaced: true,
  state: {
    from: {
      month: 0,
      year: ''
    },
    to: {
      month: 0,
      year: ''
    },
    company: '',
    companyUrl: '',
    location: {},
    name: '',
    role: '',
    currentPosition: false,
    bytes: null,
    currentExperience: null
  },
  getters: {
    formData: state => {
      return {
        from: state.from,
        to: state.to,
        currentPosition: state.currentPosition,
        company: state.company,
        companyUrl: state.companyUrl,
        role: state.role,
        location: state.location
      }
    },
    imageUrl: state => {
      if (state.currentExperience && state.currentExperience.companyImageUrl) {
        return state.currentExperience.companyImageUrl
      }

      if (state.bytes == null) {
        state.bytes = randomBytes.generate(6)
      }
      return `/api/identicons/${state.bytes}`
    }
  },
  mutations: {
    setFromMonth (state, month) {
      state.from.month = month
    },
    setFromYear (state, year) {
      state.from.year = year
    },
    setToMonth (state, month) {
      state.to.month = month
    },
    setToYear (state, year) {
      state.to.year = year
    },
    setCompany (state, company) {
      state.company = company
    },
    setCompanyUrl (state, companyUrl) {
      state.companyUrl = companyUrl
    },
    setLocation (state, location) {
      state.location = location
    },
    setCurrentPosition (state, currentPosition) {
      state.currentPosition = currentPosition
    },
    setRole (state, role) {
      state.role = role
    },
    resetData (state) {
      state.from = {
        month: 0,
        year: ''
      }
      state.to = {
        month: 0,
        year: ''
      }
      state.currentPosition = false
      state.company = ''
      state.companyUrl = ''
      state.location = {}
      state.role = ''
      state.bytes = null
      state.currentExperience = null
    },
    loadWithExperience (state, experience) {
      if (experience.fromDate) {
        const from = moment.utc(experience.fromDate)
        state.from = {
          month: from.month() + 1,
          year: `${from.year()}`
        }
      }
      if (experience.untilDate) {
        const to = moment.utc(experience.untilDate)
        state.to = {
          month: to.month() + 1,
          year: `${to.year()}`
        }
      }
      state.currentPosition = experience.isCurrentPosition
      state.company = experience.companyName
      state.companyUrl = experience.companyDomain
      state.location = {
        title: experience.location,
        placeId: experience.placeId
      }
      state.role = experience.role
      state.bytes = experience.id
      state.currentExperience = experience
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/experience-form.js